import { memo } from "react";
import { ContactInfoCardProps } from "./types";
import { useTranslate } from "helpers";
import ContactGalleryCard from "./components/ContactGalleryPreview/ContactGalleryPreview";

const ContactInfoCard: React.FC<ContactInfoCardProps> = (props) => {
  const { contactDetail } = props;

  const { t } = useTranslate();

  return (

    <div >
      <ContactGalleryCard formValues={contactDetail} />
      <div className="flex justify-between items-center pt-3 pl-4 pr-3">
        <div className="text-md font-bold text-slate-600 truncate  ">
          {contactDetail.companyName || `${contactDetail.firstName} ${contactDetail.lastName}`}
        </div>
      </div>

      <div className="pt-4 px-4">
    
        <div className="grid grid-cols-3 gap-3 mb-4">
          <div className="border border-slate-200 bg-slate-50 p-3 rounded-sm min-h-[70px]">
            <div className="text-sm text-slate-600">
              {t("admin.contact.detail.info.jobtitle")}
            </div>
            <div className="text-md font-medium text-slate-800 truncate">
              {contactDetail.jobTitle}
            </div>
          </div>
          <div className="border border-slate-200 bg-slate-50 p-3 rounded-sm min-h-[70px]">
            <div className="text-sm text-slate-600">
              {t("admin.contact.detail.info.department")}
            </div>
            <div className="text-md font-medium text-slate-800 truncate">
              {contactDetail.department}
            </div>
          </div>
          <div className="border border-slate-200 bg-slate-50 p-3 rounded-sm min-h-[70px]">
            <div className="text-sm text-slate-600">
              {t("admin.contact.detail.info.contactgroupname")}
            </div>
            <div className="text-md font-medium text-slate-800 truncate">
              {contactDetail.contactGroups?.map(g => g.name).join(", ")}
            </div>
          </div>
           <div className="border border-slate-200 bg-slate-50 p-3 rounded-sm min-h-[70px]">
            <div className="text-sm text-slate-600">
              {t("admin.contact.detail.info.personalidentificationnumber")}
            </div>
            <div className="text-md font-medium text-slate-800 truncate">
              {contactDetail.personalIdentificationNumber}
            </div>
          </div>
        </div>
      </div>
    </div>

  );
};

export default memo(ContactInfoCard);
